<template>
  
  <main class="main">

    <the-nav-titles></the-nav-titles>

    <div class="container">

      <h1 class="title title_h1">Contacts</h1>

    </div>

    <div
      v-if="!loaded"
      class="loader"
    ></div>

    <template v-else>

      <div class="container">

        <div class="layout layout_default-page">

          <div class="layout__item">
            <h2 class="title title_h2">Uffici</h2>
          </div>
    
          <div class="layout__item">

            <tabs-list @change="onChangeTabsListUffici">
              
              <template slot-scope="props">

                <tabs-item
                  v-for="(city, index) in UfficiCities"
                  :name="city.name"
                  :key="city.id"
                  v-show="index === props.activeIndex"
                >

                  <div
                    v-show="city.note !== null"
                    class="tabs-item__note"
                  >{{ city.note }}</div>
                  
                  <div class="tabs-item__contacts">
                    
                    <dl
                      v-for="(value, key) in city.contacts"
                      v-show="value !== null"
                      class="list list_tabs-item-contacts"
                    >
                      <dt class="list__term">{{ key }}</dt>
                      <dd class="list__definition">{{ value }}</dd>
                    </dl>

                  </div>

                </tabs-item>

              </template>

            </tabs-list>

          </div>

        </div>

      </div>

      <div
              v-show="currentCity && currentCity.map !== null"
              ref="mapUficci"
              class="map"
      ></div>

      <div class="container">

        <div class="layout layout_default-page">

          <div class="layout__item">
            <h2 class="title title_h2">Magazzini</h2>
          </div>

          <div class="layout__item">

            <tabs-list @change="onChangeTabsList">

              <template slot-scope="props">

                <tabs-item
                  v-for="(city, index) in cities"
                  :name="city.name"
                  :key="city.id"
                  v-show="index === props.activeIndex"
                >

                  <div
                    v-show="city.note !== null"
                    class="tabs-item__note"
                  >{{ city.note }}</div>

                  <div class="tabs-item__contacts">

                    <dl
                      v-for="(value, key) in city.contacts"
                      v-show="value !== null"
                      class="list list_tabs-item-contacts"
                    >
                      <dt class="list__term">{{ key }}</dt>
                      <dd class="list__definition">{{ value }}</dd>
                    </dl>

                  </div>

                </tabs-item>

              </template>

            </tabs-list>

          </div>

        </div>

      </div>

      <div
              v-show="currentCity && currentCity.map !== null"
              ref="map"
              class="map"
      ></div>

    </template>

    <modal-window
      v-if="modalWindowVisible && isMobile"
      @open="onOpenModalWindow"
      @close="onCloseModalWindow"
    >
      
      <div ref="modalViewMap" class="map map_modal-view"></div>

    </modal-window>
  
  </main>

</template>

<script>
  import Utils from '@/mixins/Utils';
  import ModalWindow from '@/components/ModalWindow';
  import TabsItem from '@/components/TabsItem';
  import TabsList from '@/components/TabsList';
  import TheNavTitles from '@/components/TheNavTitles';

  export default {
    name: 'ContactsPage',

    components: {
      ModalWindow,
      TabsItem,
      TabsList,
      TheNavTitles,
    },

    mixins: [
      Utils,
    ],

    data() {
      return {
        cities: [],
        UfficiCities: [],
        currentCity: null,
        loaded: false,
        modalWindowVisible: false,
      };
    },

    created() {
      this.fetchData();
    },

    methods: {
      fetchData() {
        this.$http.get('/static/api/contacts.json')

        .then(this.onFulfilled);
      },

      onFulfilled(res) {
        const data = res.data;

        this.cities = data.filter(function(item) {
            if (item.type == 'magazzini') {
                return item;
            }
        });

        this.UfficiCities = data.filter(function(item) {
            if (item.type == 'uffici') {
                return item;
            }
        });
        this.currentCity = this.cities[3];
        this.currentCityUffici = this.UfficiCities[0];

        this.loaded = true;

        this.$nextTick(() => {
          this.loadGoogleMaps();
        });
      },

      loadGoogleMaps() {
        if (window.google === undefined) {
          // @todo
          // change API_KEY for production
          const src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyAR6D6PliL9KJaX2v829LE_xrR0cVkwUV0';
          this.loadScript(src);
        } else {
            this.initGoogleMaps();
            this.initGoogleMapsUffici();
        }
      },

      loadScript(src) {
        const script = document.createElement('script');

        script.type = 'text/javascript';
        script.async = true;

        script.onload = this.initGoogleMaps;

        document.getElementsByTagName('head')[0].appendChild(script);

        script.src = src;
      },

      initGoogleMaps(mapNode) {
        this.initGoogleMapsUffici();
        // @todo
        // Needed refactor?
        if (mapNode instanceof Event) {
          mapNode = this.$refs.map;
        } else {
          mapNode = mapNode || this.$refs.map;
        }

        const styles= [
          {
            featureType: 'landscape',
            elementType: 'labels',
            stylers: [
              {
                visibility: 'off',
              },
            ],
          },
          {
            featureType: 'transit',
            elementType: 'labels',
            stylers: [
              {
                visibility: 'off',
              },
            ],
          },
          {
            featureType: 'poi',
            elementType: 'labels',
            stylers: [
              {
                visibility: 'off',
              },
            ],
          },
          {
            featureType: 'water',
            elementType: 'labels',
            stylers: [
              {
                visibility: 'off',
              },
            ],
          },
          {
            featureType: 'road',
            elementType: 'labels.icon',
            stylers: [
              {
                visibility: 'off',
              },
            ],
          },
          {
            stylers: [
              {
                hue: '#00aaff',
              },
              {
                saturation: -100,
              },
              {
                gamma: 2.15,
              },
              {
                lightness: 12,
              },
            ],
          },
          {
            featureType: 'road',
            elementType: 'labels.text.fill',
            stylers: [
              {
                visibility: 'on',
              },
              {
                lightness: 24,
              },
            ],
          },
          {
            featureType: 'road',
            elementType: 'geometry',
            stylers: [
              {
                lightness: 57,
              },
            ],
          },
        ];

        const options = {
          center: this.currentCity.map.center,
          zoom: 17,
          disableDefaultUI: true,
          styles,
          // gestureHandling: 'greedy',
        };

        const gMapInstance = new google.maps.Map(mapNode, options);

        const icon = {
          anchor: new google.maps.Point(0, 52),
          scaledSize: new google.maps.Size(41, 52),
          size: new google.maps.Size(41, 52),
          url: '/static/pin@2x.png',
        };

        const marker = new google.maps.Marker({
          icon: icon,
          map: gMapInstance,
          position: options.center,
        });

        if (this.isMobile && !this.modalWindowVisible) {
          google.maps.event.addDomListener(
            marker,
            'click',
            this.onClickGoogleMapsMarker
          );
        }
      },

      initGoogleMapsUffici(mapNode) {
        // @todo
        // Needed refactor?
        if (mapNode instanceof Event) {
          mapNode = this.$refs.mapUficci;
        } else {
          mapNode = mapNode || this.$refs.mapUficci;
        }

        const styles= [
          {
            featureType: 'landscape',
            elementType: 'labels',
            stylers: [
              {
                visibility: 'off',
              },
            ],
          },
          {
            featureType: 'transit',
            elementType: 'labels',
            stylers: [
              {
                visibility: 'off',
              },
            ],
          },
          {
            featureType: 'poi',
            elementType: 'labels',
            stylers: [
              {
                visibility: 'off',
              },
            ],
          },
          {
            featureType: 'water',
            elementType: 'labels',
            stylers: [
              {
                visibility: 'off',
              },
            ],
          },
          {
            featureType: 'road',
            elementType: 'labels.icon',
            stylers: [
              {
                visibility: 'off',
              },
            ],
          },
          {
            stylers: [
              {
                hue: '#00aaff',
              },
              {
                saturation: -100,
              },
              {
                gamma: 2.15,
              },
              {
                lightness: 12,
              },
            ],
          },
          {
            featureType: 'road',
            elementType: 'labels.text.fill',
            stylers: [
              {
                visibility: 'on',
              },
              {
                lightness: 24,
              },
            ],
          },
          {
            featureType: 'road',
            elementType: 'geometry',
            stylers: [
              {
                lightness: 57,
              },
            ],
          },
        ];

        const options = {
          center: this.currentCityUffici.map.center,
          zoom: 17,
          disableDefaultUI: true,
          styles,
          // gestureHandling: 'greedy',
        };

        const gMapInstance = new google.maps.Map(mapNode, options);

        const icon = {
          anchor: new google.maps.Point(0, 52),
          scaledSize: new google.maps.Size(41, 52),
          size: new google.maps.Size(41, 52),
          url: '/static/pin@2x.png',
        };

        const marker = new google.maps.Marker({
          icon: icon,
          map: gMapInstance,
          position: options.center,
        });

        if (this.isMobile && !this.modalWindowVisible) {
          google.maps.event.addDomListener(
            marker,
            'click',
            this.onClickGoogleMapsMarker
          );
        }
      },

      onClickGoogleMapsMarker() {
        this.showModalWindow();
      },

      onChangeTabsList(index) {
        this.currentCity = this.cities[index];
        this.initGoogleMaps();
      },

      onChangeTabsListUffici(index) {
        this.currentCityUffici = this.UfficiCities[index];
        this.initGoogleMapsUffici();
      },

      showModalWindow() {
        this.modalWindowVisible = true;
      },

      hideModalWindow() {
        this.modalWindowVisible = false;
      },

      onOpenModalWindow() {
        const mapNode = this.$refs.modalViewMap;
        this.initGoogleMaps(mapNode);
        this.initGoogleMapsUffici(mapNode);
      },

      onCloseModalWindow() {
        this.hideModalWindow();
      },
    },
  };
</script>


// WEBPACK FOOTER //
// src/pages/contacts/Index.vue